class GdprPenaltiesSwitcher {
    constructor() {
        this.articleSwitcher = document.querySelector('.blog-archive__display-switch.artykuly');
        this.penaltiesSwitcher = document.querySelector('.blog-archive__display-switch.kary-rodo');
        this.articleList = document.querySelector('.blog-archive__article-list');
        this.gdprTable = document.querySelector('.blog-archive__gdpr');
        if (this.articleSwitcher && this.articleSwitcher && this.gdprTable && this.articleList) {
            this.events();
        }
    }

    events() {
        this.articleSwitcher.addEventListener('click', () => {
            this.handleSwitcherClick(this.articleSwitcher, this.penaltiesSwitcher, this.articleList, this.gdprTable)
        })
        this.penaltiesSwitcher.addEventListener('click', () => {
            this.handleSwitcherClick(this.penaltiesSwitcher, this.articleSwitcher, this.articleList, this.gdprTable)
        })
    }

    handleSwitcherClick(clickedSwitcher, secondSwitcher, articles, gdpr ) {
        console.log('Clicked switcher');
        console.log(clickedSwitcher);
        console.log('Second switcher:');
        console.log(secondSwitcher);
        if(!clickedSwitcher.classList.contains('selected')) {
            clickedSwitcher.classList.add('selected');
            secondSwitcher.classList.remove('selected');
        }
        if (clickedSwitcher.classList.contains('kary-rodo')) {
            if (!clickedSwitcher.classList.contains('fade-out')) {
                articles.classList.add('fade-out');
                gdpr.classList.remove('fade-out');
                setTimeout(() => {
                    articles.classList.add('hidden');
                    gdpr.classList.remove('hidden');
                }, 300);   
            }
        }
        else {
            if (!clickedSwitcher.classList.contains('fade-out')) {
                articles.classList.remove('fade-out');
                gdpr.classList.add('fade-out');
                setTimeout(() => {
                    articles.classList.remove('hidden');
                    gdpr.classList.add('hidden');
                }, 300);
            }
        }
    }
}

export default GdprPenaltiesSwitcher;
